export const getRequiredPermission = (path: string) => {
    if (path.includes("/create") || path.includes("/invite") || path.includes("/management")) {
        return "add";
    }

    if (path.includes("/edit")) {
        return "edit";
    }

    if (path.includes("/delete")) {
        return "delete";
    }

    return "view";
};

export const getCurrentRoute = (
    masterRoutes: any[],
    path: string
) => {
    return (
        masterRoutes
            ?.filter(
                (r) =>
                    path.startsWith(r.path) ||
                    path.startsWith(`${r.path}/`)
            )
            ?.sort((a, b) => b.path.length - a.path.length)[0] || null
    );
};


export const hasRoutePermission = (
    masterRoutes: any[],
    accessibleRoutes: any[],
    path: string,
    permission?: string
) => {

    const currentRoute = getCurrentRoute(masterRoutes, path);

    if (!currentRoute) return false;

    const access = accessibleRoutes?.find(
        (r) => r.route === currentRoute._id
    );

    if (!access) {
        return false;
    }
    const required =
        permission || getRequiredPermission(path);

    return access?.access?.includes(required);
};
